import Vue from 'vue';
import Router from 'vue-router';
import DefaultLayout from './layouts/Default.vue';
import DefaultMicroFrontend from './layouts/DefaultMicroFrontend.vue';
import Home from './views/Home.vue';
import Login from './views/Login.vue';
import Doadores from './views/Doadores.vue';
import UploadItauBoleto from './views/UploadItauBoleto';
import UploadItauDebito from './views/UploadItauDebito';
import UploadSantanderDebito from './views/UploadSantanderDebito';
import Doador from './views/Doador';
import DoadorEdit from './views/DoadorEdit';
import Atendimento from './views/Atendimento';
import ReturnHistory from './views/ReturnHistory';
import DialyRoutinesHistory from './views/DialyRoutinesHistory';
import GeneralHistory from './views/GeneralHistory';
import RelationshipRule from './views/RelationshipRule';
import MonthReport from './views/MonthReport';
import EmailSents from './views/EmailSents';
import DonationsReport from './views/DonationsReport';

import GeneralHistoryReport from './views/GeneralHistoryReport';
import Campangn from './views/Campangn';
import EmailTemplates from '@/views/EmailTemplates';
import NewEmailTemplate from '@/views/NewEmailTemplate';
import NewCampangn from '@/views/NewCampangn';
import Remessas from '@/views/Remessas';
import EmailHistory from './views/EmailHistory';
// import EditCampangn from '@/views/EditCampangn';
import EditEmailTemplate from '@/views/EditEmailTemplate';
import EmailsReport from './views/EmailsReport';
import DoeAgoraForm from './views/microfrontend/doe-agora';
import DonationsManager from './views/microfrontend/DonationsManager';
import ListReceipts from './views/microfrontend/DonationsManager/ListReceipts';
import PersonalDataForm from './views/microfrontend/doe-agora/PersonalDataForm/PersonalDataForm';
import ValueForm from './views/microfrontend/doe-agora/ValueForm/ValueForm';
import DonatorLogin from './views/microfrontend/DonationsManager/DonatorLogin';
import ForgotPassword from './views/microfrontend/DonationsManager/DonatorLogin/ForgotPassword';
import ResetPassword from './views/microfrontend/DonationsManager/DonatorLogin/ResetPassword';
import DonatorAreaHome from './views/microfrontend/DonationsManager/Home';
import Campaigns from './views/microfrontend/DonationsManager/Campaigns';
import { getCurrentUser } from './views/microfrontend/apiClient';
import { setupAxios } from './views/microfrontend/setupAxios';
// import RelatorDonations from "./views/RelatorDonations";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/',
      component: DefaultLayout,
      children: [
        {
          path: '',
          name: 'home',
          component: Home,
          meta: { requiresAuth: true }
        },
        {
          path: 'email_history',
          name: 'email_history',
          component: EmailHistory,
          meta: { requiresAuth: true }
        },
        {
          path: '/doadores',
          name: 'doadores',
          component: Doadores,
          meta: { requiresAuth: true }
        }, {
          path: '/campanhas',
          name: 'campanhas',
          component: Campangn,
          meta: { requiresAuth: true }
        }, {
          path: '/remessas',
          name: 'remessas',
          component: Remessas,
          meta: { requiresAuth: true }
        }, {
          path: '/email-templates',
          name: 'email-templates',
          component: EmailTemplates,
          meta: { requiresAuth: true }
        }, {
          path: '/email-templates/new',
          name: 'email-templates-new',
          props: true,
          component: NewEmailTemplate,
          meta: { requiresAuth: true }
        }, {
          path: '/email-templates/edit/:id',
          name: 'email-templates-edit',
          props: true,
          component: EditEmailTemplate,
          meta: { requiresAuth: true }
        }, {
          path: '/campangn/new',
          name: 'campangn-new',
          props: true,
          component: NewCampangn,
          meta: { requiresAuth: true }

        }, /* {
>>>>>>> c57d185049a1f0bd79a52d68a05bde1108fdd559
          path: '/campangn/edit/:id',
          name: 'campangn-edit',
          props: true,
          component: EditCampangn,
          meta: { requiresAuth: true }
        }, */
        {
          path: '/donations_report',
          name: 'donations_report',
          component: DonationsReport,
          meta: { requiresAuth: true }
        }, {
          path: '/emails_report',
          name: 'emails_report',
          component: EmailsReport,
          meta: { requiresAuth: true }
        }, {
          path: '/general_history_report',
          name: 'general_history_report',
          component: GeneralHistoryReport,
          meta: { requiresAuth: true }
        }, {
          path: '/month-report',
          name: 'month-report',
          component: MonthReport,
          meta: { requiresAuth: true }
        }, {
          path: '/regua_relacionamento',
          name: 'regua_relacionamento',
          component: RelationshipRule,
          meta: { requiresAuth: true }
        }, {
          path: '/atendimento/:id',
          name: 'atendimento',
          props: true,
          component: Atendimento,
          meta: { requiresAuth: true }
        }, {
          path: '/historico_retorno',
          name: 'historico_retorno',
          props: true,
          component: ReturnHistory,
          meta: { requiresAuth: true }
        }, {
          path: '/email_sent',
          name: 'email_sent',
          props: true,
          component: EmailSents,
          meta: { requiresAuth: true }
        }, {
          path: '/historico_rotinas_diarias',
          name: 'historico_rotinas_diarias',
          props: true,
          component: DialyRoutinesHistory,
          meta: { requiresAuth: true }
        }, {
          path: '/donator/new',
          name: 'donator.new',
          component: PersonalDataForm,
          meta: { requiresAuth: true },
          props: { editing: false, admin: true }
        }, /* {
          path: '/relator_donations',
          name: 'relator_donations',
          component: RelatorDonations,
          props: true,
          meta: { requiresAuth: true }
        }, */{
          path: '/donator/edit/:id',
          name: 'donator.edit',
          component: DoadorEdit,
          props: true,
          meta: { requiresAuth: true }
        },
        {
          path: '/retorno_itau_boleto',
          name: 'retorno_itau_boleto',
          component: UploadItauBoleto,
          meta: { requiresAuth: true }
        }, {
          path: '/retorno_itau_debito',
          name: 'retorno_itau_debito',
          component: UploadItauDebito,
          meta: { requiresAuth: true }
        }, {
          path: '/returno_debito_santander',
          name: 'returno_debito_santander',
          component: UploadSantanderDebito,
          meta: { requiresAuth: true }
        }, {
          path: '/historico_geral',
          name: 'historico_geral',
          component: GeneralHistory,
          meta: { requiresAuth: true }
        }
      ]
    },
    {
      path: '/mf',
      component: DefaultMicroFrontend,
      children: [
        {
          path: 'login',
          name: 'login_donator',
          component: DonatorLogin,
          meta: { requiresAuth: false }
        },
        {
          path: 'forgot-password',
          name: 'forgot_password',
          component: ForgotPassword,
          meta: { requiresAuth: false }
        },
        {
          path: 'reset-password',
          name: 'reset_password',
          component: ResetPassword,
          meta: { requiresAuth: false }
        },
        {
          path: 'doe_agora',
          name: 'doe_agora',
          component: DoeAgoraForm,
          meta: { requiresAuth: false }
        },
        {
          path: 'home',
          name: 'donator_home',
          component: DonatorAreaHome,
          meta: { requiresAuthDonator: true }
        },
        {
          path: 'minhas-doacoes',
          name: 'donation_list',
          component: DonationsManager,
          meta: { requiresAuthDonator: true }
        },
        {
          path: 'doacao/:id/recibos',
          name: 'donation_receipts',
          component: ListReceipts,
          meta: { requiresAuthDonator: true }
        },
        {
          path: 'doacao/:id/editar',
          name: 'donation_edit',
          component: ValueForm,
          props: {
            editing: true,
            valueForm: {
              amount: '',
              recurring: ''
            }
          },
          meta: { requiresAuthDonator: true }
        },
        {
          path: 'doador/editar',
          name: 'donator_edit',
          component: PersonalDataForm,
          props: { editing: true },
          meta: { requiresAuthDonator: true }
        },
        {
          path: 'campanhas',
          name: 'mf_campanhas',
          component: Campaigns,
          meta: { requiresAuthDonator: false }
        }

      ]
    }
  ]
});

const isTokenExpired = () => {
  const token = localStorage.getItem('token');
  if (!token) {
    return true;
  }

  const nowTs = new Date().getTime();
  const tokenCreationTs = parseInt(localStorage.getItem('token_creation_ts'));
  const ttlInSeconds = localStorage.getItem('ttl') * 60;
  const hasTokenExpired = nowTs >= tokenCreationTs + ttlInSeconds;
  return hasTokenExpired;
};

const isAdminUser = async () => {
  const axios = setupAxios();
  const user = await getCurrentUser(axios);
  if (user) {
    return user.role_id === 1;
  }
  return false;
};

const checkAdminToken = async (to, next, path) => {
  const isValidAdminToken = isTokenExpired() ? false : await isAdminUser();
  if (!isValidAdminToken) {
    next({
      path,
      query: { redirect: to.fullPath }
    });
  } else {
    next();
  }
};

const checkLogin = (to, next, path) => {
  if (isTokenExpired()) {
    next({
      path,
      query: { redirect: to.fullPath }
    });
  } else {
    next();
  }
};

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    await checkAdminToken(to, next, '/login');
    return;
  }

  if (to.matched.some(record => record.meta.requiresAuthDonator)) {
    checkLogin(to, next, '/mf/login');
    return;
  }

  next();
});

export default router;
